<app-breadcrumb [master]="'ASF360'" [parentName]="'Grupy uprawnień'" [name]="'Szczegóły'"></app-breadcrumb>
<mat-tab-group (selectedTabChange)="onTabChange($event)" [(selectedIndex)]="selectedTab">
  <mat-tab label="Dane">
    <app-permission-tags-details-view *ngIf="!modify" [tag]="permissionsTag"  (modifyClicked)="modify = true; loadPermissionTag()"></app-permission-tags-details-view>
    <app-permission-tags-add *ngIf="modify" [mod]="modify" [tag]="permissionTagObject" (closeModification)="modify = false; loadPermissionTag()"></app-permission-tags-add>
  </mat-tab>



  <mat-tab label="Użytkownicy">
    <ng-template matTabContent>
     <app-all-user-list [limitedView]="true"
                        [permissionTagId]="permissionTagId"
                        [showFilter]="false"
                        [embeddedView]="true">

     </app-all-user-list>
    </ng-template>
  </mat-tab>
</mat-tab-group>
